import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AppTokenService } from "./app-token.service";
import { HttpHandlerService } from "./http-handler.service";

@Injectable({
    providedIn: 'root'
})
export class GeoService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;

    _getAllCountriesEndPoint = 'countries';
    _getAllStatesEndPoint = 'states';
    _getAllCitiesEndPoint = 'cities';
    _getAllPincodeDataEndPoint = 'pincodes'
    // _addEndPoint = 'products'
    // _updateEndPoint = 'products';
    // _updateStatus = 'products/status'
    // _getByIdEndPoint = 'products/';
    // _deleteEndPoint = 'products/';


    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }


    public GetAllCountries(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllCountriesEndPoint}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetAllStates(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllStatesEndPoint}?countrycode=${params.countrycode}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetStatesByCountryId(countryid: number): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllStatesEndPoint}/country/${countryid}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public getAllStatesList(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getAllStatesEndPoint}/list?pagelimit=${params?.length}&pageoffset=${params?.start}`
        if (params?.refresh) {
            full_api_url = full_api_url + `refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public getStateById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllStatesEndPoint}/${id}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public addState(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllStatesEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public updateState(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllStatesEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public deleteState(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllStatesEndPoint}/${id}`;
        const request_option = this._httpHandler.prepareRequest(
            'DELETE', 
            full_api_url, 
            {}
        );
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetAllCities(params?: any): Observable<any> {
        let queryParams = '';

        if (params?.statecode) {
            queryParams = `statecode=${params.statecode}`;
        } else if (params?.countryisocode) {
            queryParams = `countryisocode=${params.countryisocode}`;
        }

        const full_api_url = `${this._apiUrl}${this._getAllCitiesEndPoint}?${queryParams}`;
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public getAllCitiesList(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getAllCitiesEndPoint}/list?pagelimit=${params?.length}&pageoffset=${params?.start}`
        if (params?.refresh) {
            full_api_url = full_api_url + `refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public getCityById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllCitiesEndPoint}/${id}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public addCity(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllCitiesEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public updateCity(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllCitiesEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public deleteCity(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllCitiesEndPoint}/${id}`;
        const request_option = this._httpHandler.prepareRequest(
            'DELETE', 
            full_api_url, 
            {}
        );
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetAllPincodes(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllPincodeDataEndPoint}?countryisocode=${params?.countryisocode}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetAllPincodesList(params: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getAllPincodeDataEndPoint}/list`;
        if (params?.refresh) {
            full_api_url = full_api_url + `&refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public DeletePincodeById(id: number): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getAllPincodeDataEndPoint}/${id}`;
        const request_option = this._httpHandler.prepareRequest(
            'DELETE',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }
}



